import { Component, Input } from '@angular/core';

import { ConsumerOfferManagerHandler } from '../../providers/consumer-offer-handler';

@Component({
  selector: 'multi-redeem',
  templateUrl: 'multi-redeem.html'
})
export class MultiRedeemComponent {
	constructor(
		public offerHandler: ConsumerOfferManagerHandler,
	) {}
}



// WEBPACK FOOTER //
// ./src/components/multi-redeem/multi-redeem.ts